const translations = {
  "en": {
    "No search results yet": "No search results yet"
  },
  "zh-tw": {
    "No search results yet": "暫無搜尋結果"
  }
};

export default translations;
